import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { LoginVM } from './LoginVM';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { SecondaryButton } from 'nrcs-design-system';
import { mdiExitToApp, mdiAlertOutline } from '@mdi/js';
import Icon from '@mdi/react';
import './login.scss';

const LoginComponent = (props) => {
  const history = useHistory();

  const vm = useRef(new LoginVM(props, history)).current;

  return (
    <main className="login-page" role="main">
      <Row>
        <Col className="col-xs-10  side-bar">
          <div></div>
        </Col>
        <Col className="col-xs-10 login-container">
          <h1>
            Welcome to <br /> <b>NRCS Engineering Tool Suite</b>
          </h1>
          <div className="login-form">
            <h2 className="mt-4 mb-4">
              <b>Sign in</b>
            </h2>

            <Form onSubmit={(e) => vm.onSubmit(e)} data-testid="login-form">
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  aria-required="true"
                  className={
                    vm.activeInput.email ? 'email-input-active ' + vm.errorClass() : 'email-input ' + vm.errorClass()
                  }
                  data-testid="emailInput"
                  onChange={(e) => vm.handleChange(e)}
                  onKeyUp={(e) => vm.handleClick(e)}
                  value={vm.user.email}
                />
                {vm.formErrors.email ? (
                  <span className="usa-error-message" role="alert">
                    {vm.formErrors.email}
                  </span>
                ) : null}
                {vm.credentialError ? (
                  <span className="usa-error-message error" role="alert">
                    <Icon className="mdi-login" path={mdiAlertOutline} size={0.8} color="#b50909" />
                    {vm.credentialError}
                  </span>
                ) : null}
              </FormGroup>
              <FormGroup>
                <Label for="password">Password</Label>
                <Input
                  type="password"
                  name="password"
                  id="password"
                  aria-required="true"
                  className={
                    vm.activeInput.password
                      ? 'password-input-active ' + vm.errorClass()
                      : 'password-input ' + vm.errorClass()
                  }
                  data-testid="passwordInput"
                  onChange={(e) => vm.handleChange(e)}
                  onKeyUp={(e) => vm.handleClick(e)}
                  value={vm.user.password}
                />
                {vm.credentialError ? (
                  <span className="usa-error-message error" role="alert">
                    <Icon className="mdi-login" path={mdiAlertOutline} size={0.8} color="#b50909" />
                    {vm.credentialError}
                  </span>
                ) : null}
                {vm.formErrors.password ? (
                  <span className="usa-error-message" role="alert">
                    {vm.formErrors.password}
                  </span>
                ) : null}
              </FormGroup>
              <SecondaryButton iconLeft={mdiExitToApp} disabled={!vm.formValid} data-testid="login-button">
                Login
              </SecondaryButton>
            </Form>
          </div>
          <div className="disclaimer-info">
            <p>
              Welcome to the Usability Study for the NRCS Engineering Tool Suite (NETS) (Formerly EFT) Survey and
              Alignment tools.
            </p>
            <p>
              This invitation-only usability study is intended to get a first review of the web-based platform and GIS
              functionality being developed. This version does not represent all of the features that will be available
              in the initial or future releases. This testing is on the SFI AWS servers and not in the USDA environment.
              All sourced data is Publicly Available. No Personally Identifiable Information (PII) should be used during
              testing.
            </p>
            <p>
              Your feedback is valuable to the ongoing development of this tool. Please direct questions, login issues,
              and feedback to Eric Fleming at eric.fleming@usda.gov
            </p>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export const Login = observer(LoginComponent);
